import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import MultipleSessionSssoPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const store = getStore();

const createMultipleSessionSsoPanelScreen = ({ continueUrl, switchUrl, newUser, current }) => {
  const root = createRoot(document.getElementById('multipleSessionSsoPanel'));
  if (isSupportedBrowser()) {
    root.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <MultipleSessionSssoPanel
            continueUrl={continueUrl}
            switchUrl={switchUrl}
            newUser={newUser}
            current={current}
          />
        </AuthScreenLayout>
      </Provider>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createMultipleSessionSsoPanelScreen = createMultipleSessionSsoPanelScreen;
